export { default as Router } from './Router';
export { default as Link, goBackTo } from './Link';
export { default as AndroidBackButton } from './AndroidBackButton';
export { default as matchLocationToPath } from './matchLocationToPath';
export { default as ProtectedRoute } from './ProtectedRoute';
export { default as withProtectedFunction } from './withProtectedFunction';
export { default as DeepLinking } from './DeepLinking';

export { Route, Switch, withRouter, Redirect, matchPath } from 'react-router';



// WEBPACK FOOTER //
// ./src/@ui/NativeWebRouter/index.js